module.exports = __webpack_public_path__ + "static/media/support.ea5bc32a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/support.svg
// module id = 271
// module chunks = 0